import { CDN_TRANSLATION, DEV_MODE } from '../const';
import Translation from '../types/Translation';
import { DEFAULT_LANGUAGE, LANGUAGES, LanguagesEnum } from '../types/languages';

const _fetchLang = (lang: LanguagesEnum): Promise<Translation> => {
	const url = DEV_MODE
		? `${process.env.PUBLIC_URL}/translations/${lang}.json`
		: `${CDN_TRANSLATION}/${lang}.json`;
	return fetch(url, { mode: 'cors' }).then((response) => response.json());
};

const _filterEmptyMessages = (target: { [key: string]: string }) => {
	for (const prop in target) {
		if (!target[prop]) delete target[prop];
	}
	return target;
};

const LANGUAGES_CONTENT: Record<typeof DEFAULT_LANGUAGE, Translation | undefined> = {
	[LanguagesEnum.en]: undefined,
};

export const getDefaultLanguage = () => {
	const searchParams = new URLSearchParams(window.location.search);

	if (searchParams?.get('lang')) {
		return searchParams?.get('lang') as LanguagesEnum;
	}
	if (LANGUAGES.includes(window.navigator.language))
		return window.navigator.language as LanguagesEnum;

	return (LANGUAGES.find((lang) => [...(window.navigator.languages ?? [])].includes(lang)) ??
		DEFAULT_LANGUAGE) as LanguagesEnum;
};

export const getLanguageContent = async (): Promise<Translation | undefined | null> => {
	try {
		const language = getDefaultLanguage();
		const shouldLoadTranslation = LANGUAGES.includes(language) && DEFAULT_LANGUAGE !== language;
		const defaultLangContent = LANGUAGES_CONTENT.en ?? (await _fetchLang(DEFAULT_LANGUAGE));
		LANGUAGES_CONTENT.en = defaultLangContent;

		const langContent = shouldLoadTranslation ? await _fetchLang(language) : {};
		return {
			...defaultLangContent,
			..._filterEmptyMessages(langContent),
		};
	} catch (error) {
		console.error(error);
	}
};
